import { Navigate, Route, Routes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
//
import Layout from './layouts/LayoutFirst/Layout';
import { PrivateRoute, PrivateRoute1, PrivateRoute3 } from './privateRoute/PrivateRoute';
import {
  Register,
  ForgotPassword,
  DashboardApp,
  Products,
  Blog,
  AdminList,
  AddAdmin,
  Login,
  Privacy,
  Cookies,
  ConditionGenerale,
  MentionLegal,
  Services,
  Terms,
  About,
  Contact,
  Archive,
  Unauthorized,
  UpdateCommercial,
  UpdateClass,
  UpdateNursery,
  CommercialList,
  AddCommercial,
  NurseryList,
  AddNursery,
  Maps,
  DriverList,
  Actuality,
  AddPost,
  ChildrenList,
  ParentList,
  NannyList,
  AddClass,
  ClassList,
  FirstPage,
  Profile,
  Notification,
  NotFound,
  PaymentRequest,
  PaymentValide,
  PaiementNonValide,
  PaiementArchiver,
  ValiderPaiementCreche,
  AddNotification
} from './pages';
// ----------------------------------------------------------------------

export default function RouterConfig() {
  const ROLES = {
    Admin: 'is_admin',
    Creche: 'is_creche',
    Commercial: 'is_commercial'
  };

  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardApp />} />
        <Route
          path="admin"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin]}>
              <AdminList />
            </PrivateRoute3>
          }
        />
        <Route
          path="add_admin"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin]}>
              <AddAdmin />
            </PrivateRoute3>
          }
        />
        <Route
          path="add_nursery"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Commercial]}>
              <AddNursery />
            </PrivateRoute3>
          }
        />
        <Route
          path="nursery_list"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Commercial]}>
              <NurseryList />
            </PrivateRoute3>
          }
        />
        <Route
          path="update_nursery/:id"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Commercial]}>
              <UpdateNursery />
            </PrivateRoute3>
          }
        />
        <Route
          path="add_commercial"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin]}>
              <AddCommercial />
            </PrivateRoute3>
          }
        />
        <Route
          path="commercial_list"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin]}>
              <CommercialList />
            </PrivateRoute3>
          }
        />
        <Route
          path="update_commercial/:id"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin]}>
              <UpdateCommercial />
            </PrivateRoute3>
          }
        />
        <Route
          path="class_list"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche]}>
              <ClassList />
            </PrivateRoute3>
          }
        />
        <Route
          path="add_class"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche]}>
              <AddClass />
            </PrivateRoute3>
          }
        />
        <Route
          path="update_class/:id"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche]}>
              <UpdateClass />
            </PrivateRoute3>
          }
        />
        <Route
          path="nanny_list"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche]}>
              <NannyList />
            </PrivateRoute3>
          }
        />
        <Route
          path="parents_list"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <ParentList />
            </PrivateRoute3>
          }
        />
        <Route
          path="children_list"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <ChildrenList />
            </PrivateRoute3>
          }
        />
        <Route
          path="archive"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <Archive />
            </PrivateRoute3>
          }
        />
        <Route
          path="paymentRequest"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <PaymentRequest />
            </PrivateRoute3>
          }
        />
        <Route
          path="valide-payment"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <PaymentValide />
            </PrivateRoute3>
          }
        />
        <Route
          path="payment-non-valide"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <PaiementNonValide />
            </PrivateRoute3>
          }
        />
        <Route
          path="valide-payments-creche"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Commercial]}>
              <ValiderPaiementCreche />
            </PrivateRoute3>
          }
        />
        <Route
          path="payment-archiver"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Admin, ROLES.Creche, ROLES.Commercial]}>
              <PaiementArchiver />
            </PrivateRoute3>
          }
        />
        <Route path="products" element={<Products />} />
        <Route path="blog" element={<Blog />} />
        <Route path="profile" element={<Profile />} />
        <Route path="notification/:id" element={<Notification />} />
        <Route path="add_post" element={<AddPost />} />
        <Route
          path="add_notification"
          element={
            <PrivateRoute3 roleAllowed={[ROLES.Creche]}>
              <AddNotification />
            </PrivateRoute3>
          }
        />
        <Route path="actuality" element={<Actuality />} />
        <Route path="driver_list" element={<DriverList />} />
        <Route path="maps" element={<Maps />} />
        <Route path="unauthorized" element={<Unauthorized />} />
      </Route>
      <Route
        path="/"
        element={
          <PrivateRoute1>
            <Layout />
          </PrivateRoute1>
        }
      >
        <Route path="login" element={<Login />} />
      </Route>
      <Route
        path="/forgot_password"
        element={
          <PrivateRoute1>
            <ForgotPassword />
          </PrivateRoute1>
        }
      />
      <Route
        path="/register"
        element={
          <PrivateRoute1>
            <Register />
          </PrivateRoute1>
        }
      />
      <Route path="/" element={<Layout />}>
        <Route index element={<FirstPage />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Services />} />
        <Route path="contact" element={<Contact />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="mentions-legales" element={<MentionLegal />} />
        <Route path="condition-generale" element={<ConditionGenerale />} />
        <Route path="cookies" element={<Cookies />} />
      </Route>
      <Route path="404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  );
}

// <Route path="*" element={<Navigate to="/404" />} />
